import { NavigationsObject } from 'embeddables/src/Route'
import { EmbedMessageSettings } from 'embeddables/src/types/Settings'
import { PejerEmbeddables } from './PejerEmbeddables'

export const handleRouteSettings = (
  pejer: PejerEmbeddables,
  settings: NavigationsObject['options']
) => {
  pejer.routeHandler.setCurrentRouteSettings({ options: settings } as Partial<NavigationsObject>)
}

export const handleSettings = (pejer: PejerEmbeddables, settings: EmbedMessageSettings) => {
  handleAutoResize(pejer, settings.autoResize)
  pejer.updateSettings(settings)
}

let previousHeight = 0
// Resize observer to send height to parent
let resizeObserver: ResizeObserver | null = null
const handleAutoResize = (pejer: PejerEmbeddables, enabled: boolean) => {
  if (enabled && !resizeObserver) {
    resizeObserver = new ResizeObserver((entries) => {
      const height = entries[0].contentRect.height
      if (height === previousHeight) return
      previousHeight = height
      pejer.postToParent('resize', { height })
    })
    resizeObserver.observe(document.body)
  } else if (!enabled && resizeObserver) {
    resizeObserver.unobserve(document.body)
    resizeObserver.disconnect()
    resizeObserver = null
  }
}
